import "./src/global.css"
import React from "react"
import { ContextProvider } from "./src/Context"

export const wrapRootElement = ({ element }) => (
  <ContextProvider>{element}</ContextProvider>
)
